var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_63_1",
    "data-name": "Componente 63 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 230.947,
    height: 254.408,
    viewBox: "0 0 230.947 254.408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_820",
    "data-name": "Grupo 820",
    transform: "translate(-1719.045 -6040.609) rotate(19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_819",
    "data-name": "Grupo 819",
    transform: "translate(3657 5139.302)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_717",
    "data-name": "Ret\\xE2ngulo 717",
    width: 142,
    height: 82,
    rx: 8,
    transform: "translate(6.615 118.141)",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_718",
    "data-name": "Ret\\xE2ngulo 718",
    width: 156,
    height: 44,
    rx: 10,
    transform: "translate(-0.385 78.141)",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_23",
    "data-name": "Subtra\\xE7\\xE3o 23",
    d: "M24,14H0A15.163,15.163,0,0,1,3.515,4.1,11.131,11.131,0,0,1,12,0a11.131,11.131,0,0,1,8.485,4.1A15.163,15.163,0,0,1,24,14Z",
    transform: "translate(65.615 66.141)",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pol\\xEDgono_11",
    "data-name": "Pol\\xEDgono 11",
    d: "M29.585,16.637a11,11,0,0,1,19.084,0L68.807,51.75a11,11,0,0,1-9.542,16.473H18.99A11,11,0,0,1,9.448,51.75Z",
    transform: "translate(17.217 1) rotate(9)",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pol\\xEDgono_12",
    "data-name": "Pol\\xEDgono 12",
    d: "M29.585,16.637a11,11,0,0,1,19.084,0L68.807,51.75a11,11,0,0,1-9.542,16.473H18.99A11,11,0,0,1,9.448,51.75Z",
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 64.712, 10.83)",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_720",
    "data-name": "Ret\\xE2ngulo 720",
    width: 40,
    height: 82,
    transform: "translate(58.615 118.141)",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_719",
    "data-name": "Ret\\xE2ngulo 719",
    width: 43,
    height: 44,
    transform: "translate(57.615 78.141)",
    fill: "#FF6600"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_818",
    "data-name": "Grupo 818",
    transform: "translate(3673.053 5128.601)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_717-2",
    "data-name": "Ret\\xE2ngulo 717",
    transform: "translate(6.562 117.842)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 142,
    height: 83,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 136,
    height: 77,
    rx: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_718-2",
    "data-name": "Ret\\xE2ngulo 718",
    transform: "translate(-0.438 77.842)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 45,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 150,
    height: 39,
    rx: 7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Subtra\\xE7\\xE3o_23-2",
    "data-name": "Subtra\\xE7\\xE3o 23",
    transform: "translate(65.562 69.842)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,14H0A15.163,15.163,0,0,1,3.515,4.1,11.131,11.131,0,0,1,12,0a11.131,11.131,0,0,1,8.485,4.1A15.163,15.163,0,0,1,24,14Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15.92523670196533 8 C 15.14059352874756 7.086311817169189 13.82386207580566 6 12 6 C 10.1761474609375 6 8.859416961669922 7.086311817169189 8.074772834777832 8 L 15.92523670196533 8 M 24 14 L 23.9992504119873 14 L -1.77635683940025e-15 14 C -1.77635683940025e-15 10.25975036621094 1.248530030250549 6.74429988861084 3.514849901199341 4.100359916687012 C 5.781360149383545 1.456200003623962 8.794779777526855 -8.881784197001252e-16 12 -8.881784197001252e-16 C 15.20522022247314 -8.881784197001252e-16 18.21865081787109 1.456200003623962 20.48516082763672 4.100359916687012 C 22.75159072875977 6.744430065155029 23.99984931945801 10.25988960266113 24 13.99913024902344 L 24 14 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pol\\xEDgono_11-2",
    "data-name": "Pol\\xEDgono 11",
    transform: "translate(19.581 1) rotate(9)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.585,16.637a11,11,0,0,1,19.084,0L68.807,51.75a11,11,0,0,1-9.542,16.473H18.99A11,11,0,0,1,9.448,51.75Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 39.12748336791992 17.10997772216797 C 38.25663757324219 17.10997772216797 36.09074401855469 17.35479354858398 34.79019165039063 19.6224250793457 L 14.65229797363281 54.7346076965332 C 13.35819244384766 56.99098968505859 14.22869873046875 58.97857666015625 14.66303634643555 59.72837829589844 C 15.09737396240234 60.47819519042969 16.38842010498047 62.22217559814453 18.98957443237305 62.22217559814453 L 59.26538848876953 62.22217559814453 C 61.86653137207031 62.22217559814453 63.15757751464844 60.47821044921875 63.59191513061523 59.7283935546875 C 64.02625274658203 58.97857666015625 64.89677429199219 56.99098968505859 63.60266876220703 54.7346076965332 L 43.46477508544922 19.62244033813477 C 42.16420745849609 17.35479354858398 39.99832916259766 17.10997772216797 39.12748336791992 17.10997772216797 M 39.12748336791992 11.1099853515625 C 42.84179306030273 11.1099853515625 46.55610656738281 12.95243835449219 48.66951370239258 16.63734817504883 L 68.80740356445313 51.74953079223633 C 73.01326751708984 59.08282470703125 67.71917724609375 68.22217559814453 59.26538848876953 68.22217559814453 L 18.98957443237305 68.22217559814453 C 10.53580474853516 68.22217559814453 5.241683959960938 59.08282470703125 9.447563171386719 51.74953079223633 L 29.58545303344727 16.63734817504883 C 31.69886016845703 12.95243835449219 35.41317367553711 11.1099853515625 39.12748336791992 11.1099853515625 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pol\\xEDgono_12-2",
    "data-name": "Pol\\xEDgono 12",
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 62.347, 10.83)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.585,16.637a11,11,0,0,1,19.084,0L68.807,51.75a11,11,0,0,1-9.542,16.473H18.99A11,11,0,0,1,9.448,51.75Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 39.12749481201172 17.10997772216797 C 38.25664901733398 17.10997772216797 36.09075546264648 17.35479354858398 34.79020309448242 19.62242126464844 L 14.65229415893555 54.73463821411133 C 13.35818481445313 56.99102401733398 14.22871398925781 58.97860717773438 14.66304779052734 59.72842407226563 C 15.09738540649414 60.47822570800781 16.38843154907227 62.22220611572266 18.98958587646484 62.22220611572266 L 59.26541900634766 62.22220611572266 C 61.86655426025391 62.22220611572266 63.15760040283203 60.47822570800781 63.59194183349609 59.72842407226563 C 64.02627563476563 58.97860717773438 64.89680480957031 56.99102401733398 63.60269546508789 54.73463821411133 L 43.46478652954102 19.62244033813477 C 42.16421890258789 17.35479354858398 39.99834060668945 17.10997772216797 39.12749481201172 17.10997772216797 M 39.12749481201172 11.1099853515625 C 42.84180439453 11.1099853515625 46.55611801147461 12.95243835449219 48.66952514648438 16.63734436035156 L 68.80743408203125 51.74956130981445 C 73.01329803466797 59.08285522460938 67.71918487548828 68.22220611572266 59.26541900634766 68.22220611572266 L 18.98958587646484 68.22220611572266 C 10.53580474853516 68.22220611572266 5.241691589355469 59.08285522460938 9.447555541992188 51.74956130981445 L 29.58546447753906 16.63734436035156 C 31.69887161254883 12.95243835449219 35.41318511962891 11.1099853515625 39.12749481201172 11.1099853515625 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_720-2",
    "data-name": "Ret\\xE2ngulo 720",
    transform: "translate(58.562 117.842)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 83,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 34,
    height: 77,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_719-2",
    "data-name": "Ret\\xE2ngulo 719",
    transform: "translate(57.562 77.842)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 37,
    height: 39,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.0b52c7e986717a34a5811a5c19073156.svg";
export { ForwardRef as ReactComponent };